import { createReducer, on } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import { CourseProgress } from "src/app/shared/interfaces/course-progress";
import {
  courseProgressLoad,
  courseProgressLoadSuccess,
  loadCourseProgressFailure,
} from "../actions/course-progress.actions";

export interface CourseProgressState {
  courseProgress: CourseProgress;
  courseId: string | null;
  groupId: string | null;
  error: HttpErrorResponse | null;
}

const initialState: CourseProgressState = {
  courseProgress: null,
  courseId: null,
  groupId: null,
  error: null,
};

export const courseProgressReducer = createReducer(
  initialState,
  on(
    courseProgressLoad,
    (state, { CourseId, GroupId }): CourseProgressState => {
      const isCached = state.courseId === CourseId && state.groupId === GroupId;

      return {
        ...state,
        courseProgress: isCached ? state.courseProgress : null,
        error: null,
      };
    },
  ),
  on(
    courseProgressLoadSuccess,
    (state, action): CourseProgressState => ({
      ...state,
      courseProgress: action.courseProgress,
      courseId: action.CourseId,
      groupId: action.GroupId,
      error: null,
    }),
  ),
  on(loadCourseProgressFailure, (state, { error }) => ({
    ...state,
    error: error,
  })),
);
